module.exports = "/assets/_next/static/images/quiz-splash-bg-d9f723ef539d4badbab26ef09aaa63da.jpg";